// src/routes/core-routes.tsx
import { lazy } from 'react';
import type { RoutesProps } from './routes';
import { Navigate } from 'react-router-dom';
import {
  FiHome,
  FiSettings,
  FiLogIn,
  FiUserPlus,
  FiLock,
} from 'react-icons/fi';
import { MdDashboard } from 'react-icons/md';
import { BsQuestionCircle } from 'react-icons/bs';

// Lazy load components
const VietrroHome = lazy(() => import('@/pages/home/VietrroHomePage'));
const Dashboard = lazy(() => import('@/pages/management/Dashboard'));
const Settings = lazy(() => import('@/pages/management/Settings'));
const Login = lazy(() => import('@/pages/Login/Login'));
const RegisterPage = lazy(() => import('@/pages/Register/RegisterPage'));
const RegisterSuccess = lazy(() => import('@/pages/Register/RegisterSuccess'));
const ForgotPassword = lazy(() => import('@/pages/ForgotPassword'));
const NotFound = lazy(() => import('@/pages/management/NotFound'));
const ErrorPage = lazy(() => import('@/pages/ErrorPage'));

// Core application routes
export const coreRoutes: RoutesProps[] = [
  {
    path: "/",
    name: "navigation.dashboard",
    element: <Navigate to="/" replace />,
    icon: FiHome,
  },
  {
    path: "/dashboard",
    name: "navigation.dashboard",
    element: <Dashboard />,
    icon: MdDashboard,
  },
  {
    path: "/home",
    name: "Home Vietrro",
    element: <VietrroHome />,
    icon: FiHome,
  },
  {
    path: "/settings",
    element: <Settings />,
    name: "navigation.settings",
    icon: FiSettings,
  },
  // Auth Routes
  {
    path: "/login",
    element: <Login />,
    name: "Đăng nhập",
    icon: FiLogIn,
  },
  {
    path: "/register",
    element: <RegisterPage />,
    name: "Đăng ký",
    icon: FiUserPlus,
    roles: ['right_owner', 'licensee', 'admin', 'guest'],
  },
  {
    path: "/register-admin",
    element: <RegisterPage />,
    name: "Đăng ký Admin",
    icon: FiUserPlus,
  },
  {
    path: "/register-success",
    element: <RegisterSuccess />,
    name: "Đăng ký thành công",
    icon: FiUserPlus,
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword />,
    name: "Quên mật khẩu",
    icon: FiLock,
  },
  {
    path: "/unauthorized",
    element: <ErrorPage />,
    name: "Trang lỗi",
    icon: FiLock,
  },
  // Fallback Route
  {
    path: "*",
    element: <NotFound />,
    name: "Không tìm thấy trang",
    icon: BsQuestionCircle,
  },
];

export default coreRoutes;